export const felix_discution = require('./7_felix_discution.png');
export const kev_teach = require('./9_kev_teach.png');
